/*global angular*/

import tourText from './tourText';

export default function($log, $q, $state, $stateParams, $transitions, Swal, ProfileClass, ApiClass, Upload) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.tourText = tourText;
  vm.tourReady = tour => (vm.tour = tour);
  vm.startTour = init => {
    if (!init || (init && $stateParams.tour === 'start')) vm.tour.start();
  };
  $transitions.onExit({ exiting: 'app.author.activities.activity' }, () => {
    if (vm.tour) vm.tour.end();
  });

  vm.addQuestion = () => {
    vm.ngModel.questions.list = vm.ngModel.questions.list || [];
    const id = `checkbox_${vm.ngModel.questions.list.length + 1}`;
    const checkbox = {
      id,
      question: 'Text Area Question',
      answer: 0,
      answers: ['Question Answer', 'Question Answer', 'Question Answer', 'Question Answer']
    };
    vm.ngModel.questions.list.push(angular.copy(checkbox));
  };

  vm.checkboxInit = () => {
    if (vm.ngModel.questions.list) return;
    vm.addQuestion();
  };

  vm.submit = (activity, publish = true, redirect = true) => {
    if (publish) activity.active = true; //on publish turn activity to active

    if (activity.uuid) return update(activity, redirect);
    create(activity, redirect);
  };

  vm.removeFile = index => {
    const tempMisc = angular.copy(vm.ngModel.misc_urls);
    tempMisc.splice(index, 1);
    vm.ngModel.misc_urls = tempMisc;
    return ApiClass.activitiesIdPatch({ id: $stateParams.activity_id, manage: true }, { misc_urls: tempMisc })
      .then(() => {
        vm.ngModel.misc_urls = tempMisc;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.uploadedProductImage = link => {
    vm.ngModel.productImageUrl = link;
  };

  vm.uploadFile = file => {
    if (!file) return;
    vm.uploadBtn = true;
    const misc_urls = angular.copy(vm.ngModel.misc_urls) || [];

    ApiClass.companiesIdTypePut(
      { manage: true, id: ProfileClass.company_id, type: 'policies' },
      {
        policy: 'activity',
        uuid: $stateParams.activity_id,
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => {
        return Upload.upload({
          url: s3Policy.filePolicy.action,
          data: s3Policy.filePolicy.fields,
          file: file,
          method: 'POST',
          skipAuthorization: true
        }).then(
          function() {
            const item = {
              name: file.name,
              url: s3Policy.link,
              date: new Date().toISOString()
            };
            return $q.resolve(item);
          },
          function(resp) {
            vm.uploadBtn = false;
            $log.error('Error status: ' + resp.status);
            throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
          },
          function(evt) {
            const pdfStatus = parseInt((100.0 * evt.loaded) / evt.total);
            vm.pdfProgress = `${pdfStatus}%`;
          }
        );
      })
      .then(item => {
        misc_urls.push(item);
        return ApiClass.activitiesIdPatch({ id: $stateParams.activity_id, manage: true }, { misc_urls });
      })
      .then(() => {
        vm.uploadBtn = false;
        vm.ngModel.misc_urls = misc_urls;
        delete vm.fileToUpload;
      })
      .catch(error => {
        vm.uploadBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function update(ngModel, redirect) {
    if (!ngModel.body) return Swal.alert('Hold Up!', 'Please fill out the Activity Editor section.', 'info');
    if (!ngModel.description) return Swal.alert('Hold Up!', 'Please fill out the activity description.', 'info');

    if (!ngModel.questions.quiz) {
      delete ngModel.questions.quiz_bank;
      delete ngModel.questions.quiz_passing;
      delete ngModel.questions.list;
    }

    if (ngModel.questions.quiz_bank && ngModel.questions.quiz_bank >= ngModel.questions.list.length) {
      return Swal.alert(
        'Hold Up!',
        "Please add more questions or reduce size of question bank so that there is at least one question which will be randomly shown.  If you'd like a fixed number of questions, please select 'No' from the question bank options.",
        'info'
      );
    }

    const activity = angular.copy(ngModel);

    delete activity.progress;
    delete activity.progresses;

    ApiClass.activitiesIdPatch({ id: ngModel.uuid, manage: true }, activity)
      .then(({ data }) => {
        $log.debug('Activity Update', data);
        if (data.errorMessage) throw new Error(data.errorMessage);
        Swal.toast('Success! Activity has been updated');
        if (redirect) {
          $state.go('app.author.activities', {
            id: $stateParams.id
          });
        } else {
          vm.callback();
        }
      })
      .catch(error => {
        $log.error(error);
        Swal.alert('Hold Up!', 'Somethings not quite right, please try again', 'error');
        throw error;
      });
  }

  function create(ngModel) {
    if (!ngModel.description) return Swal.alert('Hold Up!', 'Please fill out the activity description.', 'info');

    ApiClass.activitiesPut({ manage: true }, ngModel)
      .then(({ data: { item: { uuid } } }) => {
        $state.go('app.author.activities.activity', {
          id: $stateParams.id,
          activity_id: uuid
        });
      })
      .catch(error => {
        $log.error(error);
        Swal.alert('Hold Up!', 'Somethings not quite right, please try again', 'error');
        throw error;
      });
  }

  function activate() {
    $log.debug('Activity information component activated.');

    vm.tabContainer.addEventListener('info-closed', () => {
      if (vm.tour) vm.tour.end();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/activities/activityInformation/controller.js